import React, { Component } from "react";
import { connect } from "react-redux";
// import Immutable from 'immutable';
import config from "config/api";
import { Link } from "react-router-dom";
import { isLoggedIn, getCurrentUser } from "ducks/authentication";
import Grid from "@material-ui/core/Grid";
// import Typography from '@material-ui/core/Typography';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { withStyles } from "@material-ui/core/styles";
import {
  footerBackgroundColor,
  footerLinkColor,
  footerColor,
} from "helpers/colors";

const styles = (theme) => {
  return {
    root: {
      backgroundColor: footerBackgroundColor,
      color: footerColor,
      fontSize: "11px",
      textAlign: "center",
      minHeight: "118px",
    },
    footerWrapper: {
      maxWidth: 1280,
      margin: "0 auto",
      padding: 20,
    },
    logo: {
      backgroundRepeat: "no-repeat",
      backgroundPosition: "50% 50%",
      backgroundSize: "contain",
      backgroundImage: `url(${require("assets/images/" +
        process.env.REACT_APP_SITE +
        "/logo_footer.png")})`,
      width: "100%",
      height: "40px",
      display: "block",
      margin: "0 auto",
    },
    inline: {
      display: "inline-block",
      width: "auto",
      textAlign: "center",
      [theme.breakpoints.down("sm")]: {
        padding: "10px 5px",
      },
    },
    link: {
      textDecoration: "none",
      color: footerLinkColor,
      "&:hover": {
        textDecoration: "underline",
      },
    },
    linkSmall: {
      margin: "0 5px",
      textDecoration: "underline",
      color: footerLinkColor,
      "&:hover": {
        textDecoration: "underline",
      },
    },
  };
};
class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}
  _openLink(e, link) {
    e.preventDefault();
    const conf = window.confirm(
      "En cliquant sur ce lien, vous quittez le site.\n\nSi vous souhaitez poursuivre votre navigation sur ce site internet externe, cliquez sur Continuer.\nSobi n'est pas responsable des contenus présents sur ce site internet."
    );
    if (conf) window.open(link);
  }
  render() {
    const { $$user, classes } = this.props;

    const $$menu = config.getMenu($$user, { asImmutable: true });

    return (
      <div className={classes.root}>
        <div className={classes.footerWrapper}>
          <Grid
            container
            spacing={0}
            alignItems="center"
            justify="space-around"
          >
            <Grid item xs={12} md={3}>
              <div className={classes.logo} alt="logo" />
            </Grid>
            <Grid item xs={12} md={6}>
              <List>
                {$$menu
                  .map((m, mIdx) => {
                    return (
                      <ListItem key={"fmn_" + mIdx} className={classes.inline}>
                        <ListItemText>
                          <Link className={classes.link} to={m.get("url")}>
                            {m.get("title")}
                          </Link>
                        </ListItemText>
                      </ListItem>
                    );
                  })
                  .toArray()}

                <ListItem className={classes.inline}>
                  <ListItemText>
                    <Link className={classes.link} to={"/confidentiality"}>
                      Données personnelles
                    </Link>
                  </ListItemText>
                </ListItem>
                <ListItem className={classes.inline}>
                  <ListItemText>
                    <Link className={classes.link} to={"/legal"}>
                      Conditions Générales
                    </Link>
                  </ListItemText>
                </ListItem>
              </List>
            </Grid>
            <Grid item xs={12} md={3}>
              {"© 2020 Canal" +
                process.env.REACT_APP_SITE +
                ". All rights reserved"}
              <br />
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

// export default Footer;
//
//
// export default withRouter(Header);
function mapStateToProps(state) {
  const props = {
    isLoggedIn: isLoggedIn(state),
    $$user: getCurrentUser(state),
  };
  return props;
}

export default withStyles(styles)(connect(mapStateToProps)(Footer));



// WEBPACK FOOTER //
// ./src/components/Footer.jsx